import React from "react"
import { Link } from "gatsby"
import "./index.scss"
import { AppLink } from "../appLink"
import PropTypes from "prop-types"
import Header from "../header"

const AppButton = ((props) => {

  const isAbsolute = (link) => {
    return link && link.indexOf("http") !== -1 || link.indexOf("@") !== -1;
  }
  return (
    <>
      {!props.href && <button {...props} className={`app-button ${props.className || ""}`}/>}
      {props.href && (isAbsolute(props.href)
        ? <a {...props} href={props.href || '#'} className={`app-button ${props.className || ""}`} />
        : <AppLink {...props} to={props.href || '#'} className={`app-button ${props.className || ""}`}/>)}
    </>
  )
})

AppButton.propTypes = {
  pageContext: PropTypes.object,
}

export {AppButton}
